const normalizeTimestamp = (value) => {
  const normalizedValue = String(value ?? '').trim()
  return normalizedValue ? normalizedValue : null
}

const toFiniteNumber = (value) => {
  const numericValue = Number(value)
  return Number.isFinite(numericValue) ? numericValue : 0
}

const hasCompletedAssessmentScore = (value) => {
  const normalizedValue = String(value ?? '').trim()
  return normalizedValue !== '' && normalizedValue !== '-'
}

export const hasReportCourseEngagementEvidence = (student) => {
  const progress = Math.max(
    toFiniteNumber(student?.report_course_progress),
    toFiniteNumber(student?.progress_avg),
  )
  const result = String(student?.result ?? '').trim()
  const status = String(student?.status ?? '').trim()
  const totalTimeMs = Math.max(
    toFiniteNumber(student?.report_course_total_time_ms),
    toFiniteNumber(student?.total_time_ms),
  )

  return (
    progress > 0
    || totalTimeMs > 0
    || hasCompletedAssessmentScore(student?.score)
    || result === 'Aprovado'
    || result === 'Reprovado'
    || status === 'Concluído'
    || status === 'Em andamento'
  )
}

export const resolveEffectiveReportLastAccess = (student, lifecycle) => {
  const reportLastAccess = normalizeTimestamp(student?.last_access)
  if (reportLastAccess) return reportLastAccess
  if (!hasReportCourseEngagementEvidence(student)) return null

  return (
    normalizeTimestamp(lifecycle?.lastRealSignInAt)
    || normalizeTimestamp(lifecycle?.firstLoginAt)
    || normalizeTimestamp(lifecycle?.lastSignInAt)
    || null
  )
}
